import { Heading, Text } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { outputSelector, unitsState } from "../state/state";
import { unitFormatter } from "../utils/units";
import { UnitTypes, Units } from "../types/sharedTypes";

const ResultsTextualSummary: FunctionComponent = () => {
  const { t } = useTranslation();
  const output = useRecoilValue(outputSelector);
  const unit = useRecoilValue(unitsState);

  return (
    output && (
      <>
        <Text variant="resultTextualSummaryUnit">
          {t("formatting.numberMaxOneDecimalPoint", {
            number: unitFormatter(output.range, UnitTypes.Meter, unit),
          })}{" "}
          {t(unit === Units.Metric ? "units.meter" : "units.foot")}
        </Text>
        <Heading size="sm" variant="grayDot">
          {t("components.resultsTextualSummary.range")}
        </Heading>

        <Text variant="resultTextualSummaryUnit">
          {t("formatting.numberMaxOneDecimalPoint", {
            number: unitFormatter(output.highestPoint.y, UnitTypes.Meter, unit),
          })}{" "}
          {t(unit === Units.Metric ? "units.meter" : "units.foot")}
        </Text>
        <Heading size="sm" variant="grayDot">
          {t("components.resultsTextualSummary.throwingHeight")}
        </Heading>

        <Text variant="resultTextualSummaryUnit">
          {t("formatting.numberMaxOneDecimalPoint", {
            number: unitFormatter(output.highestPoint.x, UnitTypes.Meter, unit),
          })}{" "}
          {t(unit === Units.Metric ? "units.meter" : "units.foot")}
        </Text>
        <Heading size="sm" variant="grayDot">
          {t("components.resultsTextualSummary.distanceOfHeighestPoint")}
        </Heading>

        <Text variant="resultTextualSummaryUnit">
          {t("formatting.numberMaxOneDecimalPoint", {
            number: unitFormatter(
              output.recoilInNewton / 1000,
              UnitTypes.Newton,
              unit
            ),
          })}{" "}
          {t("units.kiloNewton")}
        </Text>
        <Heading size="sm" variant="grayDot">
          {t("components.resultsTextualSummary.recoil")}
        </Heading>
        <Text variant="resultTextualSummaryUnit">
          {t("formatting.numberMaxOneDecimalPoint", {
            number: unitFormatter(
              output.impactAreaDiameter,
              UnitTypes.Meter,
              unit
            ),
          })}{" "}
          {t(unit === Units.Metric ? "units.meter" : "units.foot")}
        </Text>
        <Heading size="sm" variant="grayDot">
          {t("components.resultsTextualSummary.footprintDiameter")}
        </Heading>
      </>
    )
  );
};

export default ResultsTextualSummary;
